import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';
import {ToolsService} from './tools.service';
import {SessionStorageEnum} from '../enums/SessionStorageEnum';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private sessionID: string = null;

  constructor(private storage: StorageService, private tools: ToolsService) {}

  public getSessionID(): string {
    if (this.sessionID === null) {
      const sessionID = this.storage.read(SessionStorageEnum.SESSION_ID, true);
      if (this.tools.isNil(sessionID)) {
        this.startNewSession();
      } else {
        this.sessionID = sessionID;
      }
    }
    return this.sessionID;
  }

  private startNewSession(): void {
    this.sessionID = this.generateSessionID();
    this.storage.save(SessionStorageEnum.SESSION_ID, this.sessionID, true);
  }

  private generateSessionID(): string {
    const keyString1: string = Math.random().toString();
    const keyString2: string = Math.random().toString();
    const keySeed: number = Math.floor(Math.random() * (10 - 2 + 1)) + 2;
    const key: string = `${this.cyrb53(keyString1, keySeed)}${this.cyrb53(keyString2, keySeed)}`.substring(0, 32);
    return key.substring(0, 10) + '-' + key.substring(11);
  }

  private cyrb53(str, seed = 0): string {
    let h1 = 0xdeadbeef ^ seed,
      h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
      ch = str.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

    return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString();
  }
}
